/****************************************************
 * Module Name:  reportProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class ReportProxy {
    static GetAboveMemoDays = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/user/abovememodays",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAbovePaymentDays = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/user/abovepaymentdays",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetMaxAllowedMemoAmount = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/user/maxallowedmemoamount",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetLossByUserid = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/packetloss/reportlossbyuser",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetKapanStatusSummary = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/kapan/stonestatus/detail",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetLossBySingleUserid = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/packetloss/reportlossbyresponsibleuserid",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetLossByKapanTimeWise = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/packetloss/reportlossgroupbykapan",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleLossByKapanTimeWise = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/packetloss/lossbykapanid",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetMultipleLossByKapan = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/packetloss/multiplekapanloss",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetLossByKapanId = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/packetloss/kapanpacketloss",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetMaxMemoReminderPeriodDays = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/user/maxmemoreminderperioddays",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAbovePaymentRemainderDays = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/user/abovepaymentremainderdays",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleInvoiceDetail = (id, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/report/sales/${id}/detail`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleMemoDetail = (id, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/memo/${id}/memodetail`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleFurtherPacketDetail = (kapan, packet, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packetevaluation/${kapan}/${packet}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllCustomerWisePendingPayment = (userid, usertype, callback) => {
        let params = {
            userid: userid,
            usertype: usertype
        }
        restAPICall(
            Constants.MANAGER_URL + `/report/customer/pendingamount`,
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleCustomerWisePendingPayment = (id, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/report/customer/pendingamount/${id}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetStoneForPacketPrint = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/report/packetprint`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GeneratePacketPrintPDF = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/packetprint",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetStoneSellCountByCriteria = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/sellcount/criteria",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetInvoiceDetailByCriteria = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/invoice/criteria",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetDayWiseStoneSales = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/daywise/stonesales",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCancelledStones = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/report/cancelledstones",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCustomersForProformaHistory = (locationid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/report/proformahistory/customer/${locationid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetLatestUpdatedProformaHistoryChecked = (proformaid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/report/proformahistory/checked/${proformaid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetLatestUpdatedProformaHistory = (locationid, customerids, callback) => {

        let params = {
            locationid: locationid,
        }

        restAPICall(
            Constants.MANAGER_URL + "/report/proformahistory",
            "post",
            Constants.userToken,
            params,
            JSON.stringify(customerids),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static MarkProformaAsChecked = (proformaid, callback) => {

        restAPICall(
            Constants.MANAGER_URL + `/report/proformahistory/status/${proformaid}`,
            "post",
            Constants.userToken,
            undefined,
            undefined,
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });

    }
}
